export const SIDEBAR_COUNT_LIVE_PRODUCTS = ["SIDEBAR_COUNT_LIVE_PRODUCTS"];
export const SIDEBAR_COUNT_IMPORTED_PRODUCTS = ["SIDEBAR_COUNT_IMPORTED_PRODUCTS"];
export const SIDEBAR_COUNT_SAMPLE_ORDERS = ["SIDEBAR_COUNT_SAMPLE_ORDERS"];
export const SIDEBAR_COUNT_SHOPIFY_ORDERS = ["SIDEBAR_COUNT_SHOPIFY_ORDERS"];

export interface ISidebarCount {
  count: number;
}